// Logo resmi Fola+: gradien (public/assets/logo.png) dan putih (public/assets/logo-white.png).
interface FolaLogoProps {
  variant?: 'gradient' | 'white';
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const SIZE: Record<NonNullable<FolaLogoProps['size']>, string> = {
  sm: 'h-6',
  md: 'h-8',
  lg: 'h-12',
  xl: 'h-20',
};

export function FolaLogo({ variant = 'gradient', className = '', size = 'md' }: FolaLogoProps) {
  const white = variant === 'white';
  return (
    <img
      src={white ? '/assets/logo-white.png' : '/assets/logo.png'}
      alt="Fola+"
      width={white ? 126 : 108}
      height={white ? 71 : 53}
      draggable={false}
      className={`${SIZE[size]} w-auto select-none ${className}`}
    />
  );
}
